module.exports = __webpack_public_path__ + "2bb5146750d6b40b0748da6ba2e64de5.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/ZA.svg
// module id = OU4Y
// module chunks = 0